<script setup>

import { computed, ref, onMounted, watch } from "vue";
import useUsuarioStore from "@stores/UsuarioStore.js";
import useColaboradorStore from "@stores/ColaboradorStore.js";
import TelaTabela from '@/components/v2/telas/TelaTabela/TelaTabela.vue';
import BotaoIconeBase from '@/components/v2/base/BotaoIconeBase/BotaoIconeBase.vue';
import ERP from "@apiV2/ERP.mjs"
import View from "@apiV2/View.mjs";
import UtilArray from "@/utils/UtilArray.mjs";
import ModalVisualizarDados from "./VisualizarDados/ModalVisualizarDados.vue";
import ModalAtualizarDataDeEntregaContratual from "./AtualizarDataDeEntregaContratual/ModalAtualizarDataDeEntregaContratual.vue";
import ModalPreencherDadosComercial from "./PreencherDadosComercial/ModalPreencherDadosComercial.vue";
import ModalPreencherDadosGestor from "./PreencherDadosGestor/ModalPreencherDadosGestor.vue";
import ModalPreencherDadosCoordenador from "./PreencherDadosCoordenador/ModalPreencherDadosCoordenador.vue";
import ModalRevisarDados from "./RevisarDados/ModalRevisarDados.vue";
import ModalCancelarDados from "./CancelarDados/ModalCancelarDados.vue";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore();

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//====================== Dados Originais ===========================//
//==================================================================//

const dadosOriginais = ref([]);

//==================================================================//
//======================= Dados Original ===========================//
//==================================================================//

const dadoOriginal = ref({});

//==================================================================//
//====================== Visualizando Dado =========================//
//==================================================================//

const visualizandoDado = ref(false);

//==================================================================//
//======== MODAL ATUALIZAR DATA DE ENTREGA CONTRATUAL REF ===========//
//==================================================================//

const modalAtualizarDataDeEntregaContratualRef = ref();

//==================================================================//
//================ Preenchendo Dado Coemrcial ======================//
//==================================================================//

const preenchendoDadoComercial = ref(false);

//==================================================================//
//================== Preenchendo Dado Gestor =======================//
//==================================================================//

const preenchendoDadoGestor = ref(false);

//==================================================================//
//=============== Preenchendo Dado Coordenador =====================//
//==================================================================//

const preenchendoDadoCoordenador = ref(false);

//==================================================================//
//====================== Revisando Dado ============================//
//==================================================================//

const revisandoDado = ref(false);

//==================================================================//
//====================== Cancelando Dado ===========================//
//==================================================================//

const cancelandoDado = ref(false);

//==================================================================//
//====================== Acesso de Usuario =========================//
//==================================================================//

    // ACESSA TELA DE COMERCIAL

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE COMERCIAL SOBRESSALENTES
            // Grupo: Comercial Sobressalentes - Operação
                // User: BIANCA GOMES DE SOUZA

        // GRUPO DE COMERCIAL
            // Grupo: Comercial - Supervisor
                // User: KARINA NOGUEIRA BUENO
            // Grupo: Comercial Vendedores
                // User: CARLOS EDUARDO CAMPOS DE FREITAS
                // User: MARCELO RODRIGUES DOS SANTOS
                // User: MILTON CHIGA
                // User: CLAYTON FABIANO FERREIRA LEITE
                // User: FELIPE GIUDICE STELLA
                // User: FERNANDO MARANIM SANDOVAL

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

    // ACESSA TELA DE GESTOR

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE GESTOR
            // Grupo: Coordenação Contratos - Supervisor
                // User: RAPHAEL HENRIQUE AGUIAR DA SILVA

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

    // ACESSA TELA DE COORDENADOR

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE COORDENADOR
            // Grupo: Coordenação Contratos - Operação
                // User: FELIPE DA SILVA RIBEIRO MARIANO
                // User: KEVIN LAITA KUMAMOTO

         // GRUPO DE COMERCIAL SOBRESSALENTES
            // Grupo: Comercial Sobressalentes - Operação
                // User: BIANCA GOMES DE SOUZA

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

const usuarioGrupo = computed(()=>{

    switch(usuarioStore?.usuario?.grupoNome){
        case "Administradores":
        case "Diretoria Executivo":
            return "Administrador";
        case "Comercial Sobressalentes - Supervisor":
            return "Comercial Sobressalente Gestor"
        case "Comercial Sobressalentes - Operação":
            return "Comercial Sobressalente";
        case "Comercial - Supervisor":
        case "Comercial Vendedores":
            return "Comercial";
        case "Coordenação Contratos - Supervisor":
            return "Gestor";
        case "Coordenação Contratos - Operação":
            return "Coordenador";
        case "Fabrica Almoxarifado - Supervisão":
            return "Almoxarifado";
        default:
            return "Padrão";
    }

});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update = false)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//=================== Altera Dados Originais =======================//
//==================================================================//

const alteraDadosOriginais = (update=[])=>{

    dadosOriginais.value = update;

};

//==================================================================//
//==================== Altera Dado Original ========================//
//==================================================================//

const alteraDadoOriginal = (update={})=>{

    dadoOriginal.value = update

};

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    visualizandoDado.value = update?.modal || false;

};

//==================================================================//
//============== Altera Preenchendo Dado Comercial =================//
//==================================================================//

const alteraPreenchendoDadoComercial = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoComercial.value = update?.modal || false;

};

//==================================================================//
//================ Altera Preenchendo Dado Gestor ==================//
//==================================================================//

const alteraPreenchendoDadoGestor = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoGestor.value = update?.modal || false;

};

//==================================================================//
//============= Altera Preenchendo Dado Coordenador ================//
//==================================================================//

const alteraPreenchendoDadoCoordenador = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoCoordenador.value = update?.modal || false;

};

//==================================================================//
//======================= Altera Revisando Dado ====================//
//==================================================================//

const alteraRevisandoDado = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    revisandoDado.value = update?.modal || false;

};

//==================================================================//
//====================== Altera Cancelando Dado ====================//
//==================================================================//

const alteraCancelandoDado = async (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    cancelandoDado.value = update?.modal || false;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================ Dados ===============================//
//==================================================================//

const dados = ref([]);

//==================================================================//
//========================== HEADERS ================================//
//==================================================================//

const dadosHeaders = [
    { text: 'N° do Job',                        value: 'codigo',                        type: 'string' },
    { text: 'Status',                           value: 'status',                        type: 'string' },
    { text: 'Tipo de Job',                      value: 'jobTipo',                       type: 'string' },
    { text: 'Solicitação de Orçamento',         value: 'solicitacaoDeOrcamentoCodigo',  type: 'string' },
    { text: 'Descrição',                        value: 'descricao',                     type: 'string' },
    { text: 'Cliente',                          value: 'clienteNome',                   type: 'string' },
    { text: 'Tipo de Equipamento',              value: 'tipoDeEquipamentoDescricao',    type: 'string' },
    { text: 'Valor de Venda',                   value: 'valorDeVenda',                  type: 'money' },
    { text: 'Valor de Venda (Com Impostos)',    value: 'valorDeVendaComImpostos',       type: 'money' },
    { text: 'Data de Abertura',                 value: 'dataAbertura',                  type: 'string' },
];

//==================================================================//
//======================== Numero Filtro ===========================//
//==================================================================//

const dadoNumeroFiltro = ref("");

//==================================================================//
//======================= Cliente Filtro ===========================//
//==================================================================//

const dadoClienteFiltro = ref("");

//==================================================================//
//===================== Loading Lista de Dados =====================//
//==================================================================//

const loadingListaDeDados = ref(false);

//==================================================================//
//==================== Loaded Dados Originais ======================//
//==================================================================//

const loadedDadosOriginais = ref(false);

//==================================================================//
//======================== Dados Filtrados =========================//
//==================================================================//

const dadosFiltrados = computed(()=>{

    return dados?.value?.reduce((acc,dado)=>{

        if(!dadoNumeroFiltroValido(dado?.codigo)){
            return acc;
        }

        if(!dadoClienteFiltroValido(dado?.clienteNome)){
            return acc;
        }

        acc.push(dado);

        return acc;

    },[]);

});

//==================================================================//
//======================= Dado Numero Valido =======================//
//==================================================================//

const dadoNumeroFiltroValido = (dadoCodigo) =>{

    if(dadoNumeroFiltro.value === ""){
        return true;
    }

    if(dadoCodigo != dadoNumeroFiltro.value){
        return false;
    }

    return true;

};

//==================================================================//
//====================== Dado Cliente Valido =======================//
//==================================================================//

const dadoClienteFiltroValido = (clienteNome) =>{

    if(dadoClienteFiltro.value === ""){
        return true;
    }

    if(clienteNome != dadoClienteFiltro.value){
        return false;
    }

    return true;

};

//==================================================================//
//==================== Altera Dado Numero Filtro ===================//
//==================================================================//

const alteraDadoNumeroFiltro = (dado) =>{

    dadoNumeroFiltro.value = dado?.codigo || "";

};

//==================================================================//
//==================== Altera Dado Cliente Filtro ==================//
//==================================================================//

const alteraDadoClienteFiltro = (dado) =>{

    dadoClienteFiltro.value = dado?.clienteNome || "";

};

//==================================================================//
//====================== FILTROS CONFIGURADOS =======================//
//==================================================================//

const filtros = computed(() => [

    { label: 'N°',       items: dados.value, itemText: 'codigo',      onChange: alteraDadoNumeroFiltro },
    { label: 'Cliente',  items: dados.value, itemText: 'clienteNome', onChange: alteraDadoClienteFiltro },

]);

//==================================================================//
//================= Altera Loading Lista de Dados ==================//
//==================================================================//

const alteraLoadingListaDeDados = (update = false) =>{

    alteraControlesDesativados(update || false);
    loadingListaDeDados.value = update || false;

};

//==================================================================//
//================= Altera Loaded Dados Originais ==================//
//==================================================================//

const alteraLoadedDadosOriginais = (update = false) =>{

    loadedDadosOriginais.value = update || false;

};

//==================================================================//
//================== Load Dados Originais ==========================//
//==================================================================//

const loadDadosOriginais = async () =>{

    alteraLoadedDadosOriginais(false);

    const dadosResponse = await ERP.getManyWithView(View.JOB,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore?.usuario?.id
        },
    ]);

    alteraDadosOriginais(dadosResponse.data);

    alteraLoadedDadosOriginais(true);

};

//==================================================================//
//======================= Load Lista de Dados ======================//
//==================================================================//

const loadListaDeDados = async () =>{

    alteraLoadingListaDeDados(true);

    await loadDadosOriginais();

    alteraLoadingListaDeDados(false);

};

//==================================================================//
//=========================== Altera Dados =========================//
//==================================================================//

const alteraDados = (update = []) =>{

    dados.value = update || []

};

//==================================================================//
//======================= Prepara Cartao ===========================//
//==================================================================//

const preparaCartao = ()=>{

    preparaDados(UtilArray?.clone(dadosOriginais.value));

}

//==================================================================//
//========================= Prepara Dados ==========================//
//==================================================================//

const preparaDados = async (dadosParaPreparar = []) =>{

    const dadosPreparados = dadosParaPreparar.map((dado,index)=>{

        return{
            id: dado?.id || "",
            jobTipo: dado?.jobTipo || "",
            index: index ?? null,
            codigo: dado?.codigo || "",
            status: dado?.status || "",
            descricao: dado?.descricao || "",
            dataAbertura: dado?.dataAberturaFormatada || "",
            valorDeCusto: dado?.valorDeCusto || 0,
            valorDeVenda: dado?.valorDeVenda || 0,
            valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,
            clienteID: dado?.cliente?.id || "",
            clienteNome: dado?.cliente?.nomeFantasia || "",
            solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
            solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
            tipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
            tipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",
            owners: dado?.owners || [],
        }

    });

    alteraDados(dadosPreparados);

};

//==================================================================//
//========================== Usuario Dono ===========================//
//==================================================================//

const usuarioDono = (dado = {}) => {

    let usuarioID = usuarioStore?.usuario?.id || "";
    let dadoOwners = dado?.owners || [];

    if(!usuarioID){
        return false;
    }

    return dadoOwners.includes(usuarioID);

};

//==================================================================//
//=============== Permite Preenchendo Dado Comercial ================//
//==================================================================//

const permitePreenchendoDadoComercial = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(usuarioDono(dado) == false){
        return false;
    }

    if(grupo == "Gestor"){
        return false;
    }

    if(grupo == "Coordenador"){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(dadoStatus != "Iniciado"){
        return false;
    }

    return true;

};

//==================================================================//
//================= Permite Preenchendo Dado Gestor =================//
//==================================================================//

const permitePreenchendoDadoGestor = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(grupo == "Comercial Sobressalente"){
        return false;
    }

    if(grupo == "Comercial"){
        return false;
    }

    if(grupo == "Coordenador"){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(dadoStatus != "Aguardando Gestor"){
        return false;
    }

    return true;

};

//==================================================================//
//============= Permite Preenchendo Dado Coordenador ================//
//==================================================================//

const permitePreenchendoDadoCoordenador = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(usuarioDono(dado) == false){
        return false;
    }

    if(grupo == "Comercial"){
        return false;
    }

    if(grupo == "Gestor"){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(dadoStatus != "Aguardando Coordenador"){
        return false;
    }

    return true;

};

//==================================================================//
//====================== Permite Revisando Dado ======================//
//==================================================================//

const permiteRevisandoDado = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(usuarioDono(dado) == false){
        return false;
    }

    if(grupo == "Gestor"){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(
        dadoStatus != "Em Execução" &&
        dadoStatus != "Em Revisão"
    ){
        return false;
    }

    return true;

};

//==================================================================//
//======= Permite Atualizar Data de Entrega Contratual ===============//
//==================================================================//

const permiteAtualizarDataDeEntregaContratual = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(usuarioDono(dado) == false){
        return false;
    }

    if(grupo == "Gestor"){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(dadoStatus != "Em Execução"){
        return false;
    }

    return true;

};

//==================================================================//
//====================== Permite Cancelar Dado =======================//
//==================================================================//

const permiteCancelarDado = (dado = {}) => {

    let grupo = usuarioGrupo.value;
    let dadoStatus = dado?.status;

    if(usuarioDono(dado) == false){
        return false;
    }

    if(grupo == "Padrão"){
        return false;
    }

    if(dadoStatus != "Iniciado"){
        return false;
    }

    return true;

};

//==================================================================//
//========================== Desativa Botao ==========================//
//==================================================================//

const desativaBotao = computed(() => {

    if(controlesDesativados.value == true){
        return true;
    }

    if(loadingListaDeDados.value == true){
        return true;
    }

    if(dadoOriginal.value?.id){
        return true;
    }

    return false;

});

//==================================================================//
//===================== DADO ORIGINAL POR ID ==========================//
//==================================================================//

const dadoOriginalPor = (dado = {}) => {

    return dadosOriginais.value?.[dado?.index] ?? {};

};

//==================================================================//
//======================== Ao Visualizar Dado ======================//
//==================================================================//

const aoVisualizarDado = (dado = {})=>{

    alteraVisualizandoDado({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//========= Ao Atualizar Data de Entrega Contratual ==================//
//==================================================================//

const aoAtualizarDataDeEntregaContratual = async (dado = {})=>{

    await modalAtualizarDataDeEntregaContratualRef.value?.abrirModal(dadoOriginalPor(dado));

};

//==================================================================//
//=================== Ao Preencher Dado Comercial ==================//
//==================================================================//

const aoPreencherDadoComercial = (dado = {})=>{

    alteraPreenchendoDadoComercial({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//==================== Ao Preencher Dado Gestor ====================//
//==================================================================//

const aoPreencherDadoGestor  = (dado = {})=>{

    alteraPreenchendoDadoGestor({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//================= Ao Preencher Dado Coordenador ==================//
//==================================================================//

const aoPreencherDadoCoordenador = (dado = {})=>{

    alteraPreenchendoDadoCoordenador({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//======================== Ao Revisar Dado =========================//
//==================================================================//

const aoRevisarDado = (dado = {})=>{

    alteraRevisandoDado({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//======================== Ao Cancelar Dado =========================//
//==================================================================//

const aoCancelarDado = (dado = {})=>{

    alteraCancelandoDado({ dado: dadoOriginalPor(dado), modal: true });

};

//==================================================================//
//======== Carrega os Dados Originais Quando montar a Tela =========//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadListaDeDados();

});

//======================================================================================//
//=== Prepara Cartao de Lista de Dados se Dados Originais Carregados ou Recarregados ===//
//============================ Watch => loadedDadosOriginais ===========================//
//======================================================================================//

watch(()=> loadedDadosOriginais.value, () => {

    if(loadedDadosOriginais.value == true){
        preparaCartao();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//=================== Watch => visualizandoDado ====================//
//==================================================================//

watch(visualizandoDado, async () => {

    if(visualizandoDado.value == false){
        await loadListaDeDados();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//=============== Watch => preenchendoDadoComercial ================//
//==================================================================//

watch(preenchendoDadoComercial, async () => {

    if(preenchendoDadoComercial.value == false){
        await loadListaDeDados();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//================ Watch => preenchendoDadoGestor ==================//
//==================================================================//

watch(preenchendoDadoGestor, async () => {

    if(preenchendoDadoGestor.value == false){
        await loadListaDeDados();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//============= Watch => preenchendoDadoCoordenador ================//
//==================================================================//

watch(preenchendoDadoCoordenador, async () => {

    if(preenchendoDadoCoordenador.value == false){
        await loadListaDeDados();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//=================== Watch => revisandoDado =======================//
//==================================================================//

watch(revisandoDado, async () => {

    if(revisandoDado.value == false){
        await loadListaDeDados();
    }

});

//==================================================================//
//====== Recarregado os Dados Originais Quando fechar o Modal ======//
//=================== Watch => cancelandoDado =======================//
//==================================================================//

watch(cancelandoDado, async () => {

    if(cancelandoDado.value == false){
        await loadListaDeDados();
    }

});

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <TelaTabela
            :disabled="loadingListaDeDados"
            :filtros="filtros"
            :headers="dadosHeaders"
            :dados="dadosFiltrados"
            paginacao="paginada"
        >

            <template #tela-titulo>

                Jobs

            </template>

            <template #tabela-linha-botoes="{ dado, disabled }">

                <BotaoIconeBase
                    icon="mdi-eye"
                    color="#32434D"
                    text="Visualizar"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoVisualizarDado(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permitePreenchendoDadoComercial(dado)"
                    icon="mdi-rocket-launch"
                    color="#3E737B"
                    text="Preencher Job"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoPreencherDadoComercial(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permitePreenchendoDadoGestor(dado)"
                    icon="mdi-rocket-launch"
                    color="#3E737B"
                    text="Preencher Job"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoPreencherDadoGestor(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permitePreenchendoDadoCoordenador(dado)"
                    icon="mdi-rocket-launch"
                    color="#3E737B"
                    text="Preencher Job"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoPreencherDadoCoordenador(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteRevisandoDado(dado)"
                    icon="mdi-book-edit-outline"
                    color="#4F6563"
                    text="Revisar Job"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoRevisarDado(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteAtualizarDataDeEntregaContratual(dado)"
                    icon="mdi-calendar-edit"
                    color="#3E737B"
                    text="Atualizar Data de Entrega Contratual"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoAtualizarDataDeEntregaContratual(dado)"
                ></BotaoIconeBase>

                <BotaoIconeBase
                    v-if="permiteCancelarDado(dado)"
                    icon="mdi-cancel"
                    color="#654f4f"
                    text="Cancelar Job"
                    :disabled="disabled || desativaBotao"
                    :click="() => aoCancelarDado(dado)"
                ></BotaoIconeBase>

            </template>

            <template #modais>

                <ModalVisualizarDados
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dadoOriginal="dadoOriginal"
                    :visualizandoDado="visualizandoDado"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraVisualizandoDado="alteraVisualizandoDado"
                ></ModalVisualizarDados>

                <ModalAtualizarDataDeEntregaContratual
                    ref="modalAtualizarDataDeEntregaContratualRef"
                    :onClose="loadListaDeDados"
                ></ModalAtualizarDataDeEntregaContratual>

                <ModalPreencherDadosComercial
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dadoOriginal="dadoOriginal"
                    :preenchendoDadoComercial="preenchendoDadoComercial"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraPreenchendoDadoComercial="alteraPreenchendoDadoComercial"
                ></ModalPreencherDadosComercial>

                <ModalPreencherDadosGestor
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dado="dadoOriginal"
                    :preenchendoDadoGestor="preenchendoDadoGestor"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraDado="alteraDadoOriginal"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraPreenchendoDadoGestor="alteraPreenchendoDadoGestor"
                ></ModalPreencherDadosGestor>

                <ModalPreencherDadosCoordenador
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dado="dadoOriginal"
                    :preenchendoDadoCoordenador="preenchendoDadoCoordenador"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraPreenchendoDadoCoordenador="alteraPreenchendoDadoCoordenador"
                    @update:alteraDado="alteraDadoOriginal"
                ></ModalPreencherDadosCoordenador>

                <ModalRevisarDados
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dadoOriginal="dadoOriginal"
                    :revisandoDado="revisandoDado"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraRevisandoDado="alteraRevisandoDado"
                ></ModalRevisarDados>

                <ModalCancelarDados
                    :usuarioStore="usuarioStore"
                    :colaboradorStore="colaboradorStore"
                    :dadoOriginal="dadoOriginal"
                    :cancelandoDado="cancelandoDado"
                    :controlesDesativados="controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraCancelandoDado="alteraCancelandoDado"
                ></ModalCancelarDados>

            </template>

        </TelaTabela>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none;
}

</style>
